document.addEventListener('DOMContentLoaded', () => {

  const menuButton = document.querySelector('[aria-controls=sitemenu]');
  const pages = document.querySelectorAll('.site-menu__pages > li');
  const indicator = document.querySelector('.site-menu__indicator');
  const nav = document.querySelector('.site-menu');
  const closeButton = document.querySelector('.site-menu__close');
  const parentLoungeButton = document.querySelector('[aria-controls=parent-lounge]');
  const parentLoungeQuick = document.querySelector('[aria-controls=parent-lounge-quick]');
  const parentLoungeQuickLinks = document.querySelector('#parent-lounge-quick');
  const searchButton = document.querySelector('[aria-controls=search]');
  const searchForm = document.querySelector('#header-search-form');
  const main = document.querySelector('#main');
  const bg = document.querySelector('.site-menu__bg');
  const menuDelayCap = 70;
  var menuInterval = null;
  var menuDelay = 0;

  menuButton.addEventListener('click', () => {
    main.classList.toggle('is-menu-open');
    if (isMenuOpen()) {
      menuButton.querySelector('.icon use').setAttribute('href', '#close');
      menuButton.querySelector('.visually-hidden').innerHTML = 'Close';
    } else {
      menuButton.querySelector('.icon use').setAttribute('href', '#menu');
      menuButton.querySelector('.visually-hidden').innerHTML = 'Open';
    }
  });

  function isMenuOpen() {
    return main.classList.contains('is-menu-open') === true;
  }

  // When the escape key is pressed, close the menu.
  document.addEventListener('keydown', e => {
    if (isMenuOpen() && e.key === 'Escape') {
      main.classList.remove('is-menu-open');
      nav.classList.remove('is-expanded');
      pages.forEach(page => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });
      clearInterval(menuInterval);
      menuDelay = 0;
    }
  });

  if (searchButton) {
    searchButton.addEventListener('click', (e) => {
      const active = true;
      searchButton.setAttribute('aria-expanded', String(active));
      searchButton.setAttribute('aria-hidden', String(active));
      searchButton.hidden = active;
      searchForm.setAttribute('aria-expanded', String(active));
      searchForm.setAttribute('aria-hidden', String(!active));
      searchForm.hidden = !active;
      searchForm.querySelector('input').focus();
      e.preventDefault();
    });
  }

  // if (parentLoungeButton) {
  //   parentLoungeButton.addEventListener('click', (e) => {
  //     document.querySelector('[data-id=parent-lounge] .site-menu__link').click();
  //     e.preventDefault();
  //   });
  // }

  // if (parentLoungeQuick) {
  //   var parentLoungeQuickActive = false;
  //   parentLoungeQuick.addEventListener('click', (e) => {
  //     parentLoungeQuickActive = !parentLoungeQuickActive;
  //     console.log(parentLoungeQuickActive);
  //     parentLoungeQuick.setAttribute('aria-expanded', String(parentLoungeQuickActive));
  //     parentLoungeQuickLinks.setAttribute('aria-hidden', String(!parentLoungeQuickActive));
  //     parentLoungeQuickLinks.hidden = !parentLoungeQuickActive;
  //     // document.querySelector('.btn-hover__menu#parent-lounge').click();
  //     e.preventDefault();
  //   });
  // }

  pages.forEach(el => {

    const resizeBg = () => {

      var height = el.querySelector(':scope > .site-menu__section').offsetHeight;
      height += document.querySelector('.site-header').offsetHeight;
      bg.style.height = height + 'px';

    }

    const toggle = (e) => {

      clearInterval(menuInterval);
      menuDelay = 0;
      if (e.target.parentNode.parentNode.getAttribute('aria-expanded') === 'true') {
        contract();
      } else {
        expand();
      }
      e.preventDefault();
      return false;

    };

    const contract = () => {

      main.classList.remove('is-menu-open');
      nav.classList.remove('is-expanded');

      pages.forEach(page => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });

      if (searchButton) {
        searchButton.setAttribute('aria-expanded', String(false));
        if (el.hasAttribute('aria-expanded')) {
          el.setAttribute('aria-expanded', false);
          el.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', true);
          el.querySelector(':scope > .site-menu__section').hidden = true;
        }
      }

    };

    const expand = () => {

      menuDelay = menuDelayCap;

      main.classList.add('is-menu-open');
      nav.classList.add('is-expanded');

      pages.forEach(page => {
        const active = page === el;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page.querySelector(':scope > .site-menu__section').setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });

      resizeBg();
    };

    const hover = () => {

      // Position the indicator element over the top of the active page.
      Object.assign(indicator.style, {
        left: el.offsetLeft+'px',
        width: el.offsetWidth+'px'
      });
      indicator.classList.add('is-active');
    };

    const hoverIf = (condition, e) => {
      if (condition(e)) {
        clearInterval(menuInterval);
        menuDelay = menuDelayCap;
        menuInterval = setInterval(() => {
          if (menuDelay > 0) {
            menuDelay -= 1;
            if (menuDelay <= 0) {
              if (e.target.parentNode.hasAttribute('aria-expanded')) {
                expand();
              } else {
                contract();
              }
            }
          }
        }, 1);
      }
    };

    const leaveA = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
      indicator.classList.remove('is-active');
    };

    const leave = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
      indicator.classList.remove('is-active');
    };

    const expandIf = (condition, e) => {
      if (condition(e)) {
        expand();
        e.preventDefault();
      }
    };

    const expandHoverIf = (condition, e) => {
      if (condition(e) && (menuDelay <= 0 || !isMenuOpen()) ) {
        if (e.target.parentNode.hasAttribute('aria-expanded')) {
          expand();
        } else {
          contract();
        }
        e.preventDefault();
      }
    };

    const contractIf = (condition, e) => {
      clearInterval(menuInterval);
      menuDelay = 0;
      if (condition(e)) {
        contract();
        e.preventDefault();
      }
    };

    const expandIfMobile = expandIf.bind(undefined, e => {
      return window.matchMedia("(max-width: 1200px)").matches && e.target.closest('.site-menu__li').hasAttribute('aria-expanded');
    });

    const hoverIfMobile = hoverIf.bind(undefined, e => {
      return window.matchMedia("(max-width: 1200px)").matches;
    });

    const hoverIfDesktop = hoverIf.bind(undefined, e => {
      return window.matchMedia("(min-width: 1200px)").matches;
    });

    const expandHoverIfDesktop = expandHoverIf.bind(undefined, e => {
      return window.matchMedia("(min-width: 1200px)").matches;
    });

    const contractIfDesktop = contractIf.bind(undefined, e => {
      return window.matchMedia("(min-width: 1200px)").matches;
    });

    const back = el.querySelector('.site-menu__back > button');
    if (back) {
      back.addEventListener('click', () => {
        nav.classList.remove('is-expanded');
        el.setAttribute('aria-expanded', 'false');
        el.querySelector('.site-menu__section').setAttribute('aria-hidden', String(true));
        el.querySelector('.site-menu__section').hidden = true;
      });
    }

    const closeButton = el.querySelector('.site-menu__close');
    if (closeButton) {
      closeButton.addEventListener('click', contract);
    }

    const toggleButton = el.querySelector('.site-menu__link-toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', toggle);
    }

    const a = el.querySelector(':scope > a');
    a.addEventListener('click', expandIfMobile);
    // a.addEventListener('mouseenter', hoverIfMobile);
    a.addEventListener('mouseleave', leaveA);
    // a.addEventListener('focus', hoverIfMobile);
    nav.addEventListener('mouseleave', leave);

    a.addEventListener('mouseenter', hoverIfDesktop);
    a.addEventListener('mouseenter', expandHoverIfDesktop);
    nav.addEventListener('mouseleave', contractIfDesktop);

    contract();
  });
});
